// 매출분석 결제수단 표시 정보 — 결제수단 카드·도넛·필터 배지·주간 차트 부제가 함께 쓴다
export const PAYMENT_META = {
  account: { label: "계좌이체", color: "#7F77DD" },
  vbank: { label: "가상계좌", color: "#EF9F27" },
  card: { label: "카드", color: "#D85A30" },
  point: { label: "포인트", color: "#4CAF82" },
};
